/**
 * TODO STE-1606: replace this placeholder header with proper JSDoc and a Storybook story
 * WIP
 */
import React from "react";

import { css, cx } from "@emotion/css";

import { useStyles } from "@/hooks/useStyles.ts";
import { Theme } from "@/theme/CreateTheme.ts";
import { AtomProps } from "@/uiKit/atoms/utils/AtomTypes.ts";

export type TagListProps = AtomProps<{
  /**
   * The content of the component.
   */
  children?: React.ReactNode;
}>;

export const TagList: React.FC<TagListProps> = ({ children, className, ...props }) => {
  const styles = useStyles(makeStyles);

  return (
    <ul className={cx(styles.container, className)} {...props}>
      {children}
    </ul>
  );
};

const makeStyles = (theme: Theme) => ({
  container: css`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: ${theme.spacing(4)};
  `,
});
